import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { useMobile } from 'common-ui/hooks/useMobile'

interface SidebarContextType {
    open: boolean
    toggle: () => void
    onOpen: () => void
    onClose: () => void
}

const SidebarContext = createContext<SidebarContextType>({
    open: true,
    // oxlint-disable-next-line no-empty-function
    toggle: () => {},
    // oxlint-disable-next-line no-empty-function
    onOpen: () => {},
    // oxlint-disable-next-line no-empty-function
    onClose: () => {},
})

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
    const { isMobile } = useMobile()
    const [open, setOpen] = useState(() => window.innerWidth >= 768)

    useEffect(() => {
        setOpen(!isMobile)
    }, [isMobile])

    const toggle = useCallback(() => setOpen((v) => !v), [])
    const onOpen = useCallback(() => setOpen(true), [])
    const onClose = useCallback(() => setOpen(false), [])

    return <SidebarContext.Provider value={{ open, toggle, onOpen, onClose }}>{children}</SidebarContext.Provider>
}

export const useSidebar = () => useContext(SidebarContext)
